import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ReactiveFormsModule} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { Placa } from 'src/app/model/datos-maestros/placa';
import { Chofer, muelleAsigando } from '../../../traslado-logist/model/model';
import { EmpleadoEppService } from 'src/app/aplicaciones-modulos/epp/services/punto-entrega/empleado-epp.service';
import { ComedorService } from 'src/app/aplicaciones-modulos/comedor/services/comedor.services';
import { ITiposPlanificacion } from '../../model/modelConfiguracional';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { EquiposMarquesinaService } from '../../service/equiposMarquesinas.service';
import { IBasculaSentidoRequest, IMensajesRequest } from '../../model/modelOnlyServices';
import { ConfiguracionMotivosDeDesbloqueosService } from 'src/app/aplicaciones-modulos/balanza/services/configuracion-motivos-de-desbloqueos.service';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-tracking-anden',
  templateUrl: './tracking-anden.component.html',
  styleUrls: ['./tracking-anden.component.css'],
})
export class TrackingAndenComponent implements OnInit {

  public DAT_TITULOS = diccionarios.titulos.supervisor;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;
  public DAT_BTNCSS  = diccionarios.button.buttonsCss;
  public CONSTANTES  = diccionarios.rutas;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : any[] = [];
  public rowData        : any[] = [];
  public rowClassRules  : any;
  public rowSelection   : any;
  public gridApi        : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  // variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listAgencias   : any[] = [];
  public listAdenes     : muelleAsigando[] = [];
  public cmbxEstados    : any[] = [];
  public routear        : "Anden";
  public isOperador     : boolean = false;
  public selected       : ITrackingViajes;
  public fechaInicio    : Date;
  public listSello      : any[] = [];
  public mostrarForm    : boolean = false;
  public textBotonGuardar: String = "Enviar a Cargar";

  public listAreas      : any[] = [];
  public tiposEstibas: Array<{ id: string; label: string }> = [];
  
  public formulario = new FormGroup({
    idViaje       : new FormControl(''),
    tipo          : new FormControl('', Validators.required),
    proveedorId   : new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern('^[0-9]*$')]),
    proveedorNombre:new FormControl('', Validators.required),
    choferCedula  : new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    choferNombre  : new FormControl('', Validators.required),
    choferTelefono: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    placa         : new FormControl('', [Validators.required, Validators.maxLength(10)]),
    furgon        : new FormControl('', [Validators.required, Validators.maxLength(10)]),
    centroOrigen  : new FormControl('', [Validators.maxLength(4)]),
    bodegaCarga   : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    fechaLlegada  : new FormControl('', Validators.required),
    observacion   : new FormControl('', Validators.maxLength(250)),
    estado        : new FormControl(),
    centroDestino : new FormControl('', [Validators.maxLength(4)]),
    creadoPor     : new FormControl(''),
    detallePlaca  : new FormControl('', Validators.required),
    detalleFurgon : new FormControl(''),
    sellosAdd     : new FormControl(''),
    sellos        : new FormControl(''),
    andenId       : new FormControl(''),

    });

  public formAnden= new FormGroup({
    viajeId       : new FormControl('', Validators.required),
    andenId       : new FormControl('', Validators.required),
    centroDestino : new FormControl(''),
    centroOrigen  : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    bodegaCarga   : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    texto         : new FormControl('', Validators.required),
    creadoPor     : new FormControl(''),
    
    areaId        : new FormControl(''),
    });

  public formActividad= new FormGroup({
    viajeId           : new FormControl('', Validators.required),
    colaborador       : new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
    colaboradorCargo  : new FormControl('', Validators.required),
    colaboradorNombre : new FormControl('', Validators.required),
    tipoEstiba        : new FormControl(''),
    creadoPor         : new FormControl('', Validators.required),
    motivoBloqueo     : new FormControl(null),
    requiereDoc       : new FormControl(true),
    });

  public formCarga = new FormGroup({
    viajeId       : new FormControl('', Validators.required),
    tipo          : new FormControl('ADICIONALES'),
    descripcion   : new FormControl('', Validators.required),
    cantidad      : new FormControl('', [Validators.required,  Validators.pattern('^[0-9]*$')]),
    creadoPor     : new FormControl(''),
    modificadoPor : new FormControl(''),
    });

  private subscription = new Subscription();

  constructor(
    private utilServices  : UtilsService,
    private dmaestrosAPI  : DatosMaestrosService,
    private logisticaAPI  : LogisticaService,
    private _catalogos    : CatalogosLogisticaService,
    private rutaActiva    : ActivatedRoute,
    private nominaAPI     : ComedorService,
    private trackingConfiguracional: TrackingConfiguracionService,
    private balanzaMotivosBloqueosAPI: ConfiguracionMotivosDeDesbloqueosService,

    /**Integracion de servicios con equipos y sensores */
    private usuarioBasculaAPI: UsuarioBasculaGaritaService,
    private onlyControlSensoresAPI: EquiposMarquesinaService,    
  ) { }

  label = "Asignar anden";
  //ANDEN-1 | CUADRILLA | SELLOS
  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    console.log("ejecuta oNinit"); 
    this.formActividad.get('tipoEstiba').valueChanges.subscribe((tipoEstiba) => {
      this.listColaborador = (this.listColaborador || []).map((e) => ({ ...e, tipoEstiba }));
      console.log("Value Canges this.listColaborador", this.listColaborador);
    });
    
    this.rutaActiva.params.subscribe((params: Params) => {
      console.log('Router-Params: ' + params.proceso);
      //this.isOperador = params.proceso == "operador";
      this.routear = params.proceso;
    
      switch (this.routear) {
        case this.CONSTANTES.OPERADOR:
          this.isOperador = true;
          this.label = "Iniciar Carga";
          this.DAT_TITULOS.titulo = "Asignacion de Cuadrilla";
          break; 
        case this.CONSTANTES.SELLOS:
          this.isOperador = false;
           this.label = "Asignar Sellos";
          break; 
        default:
          this.routear = "Anden";
          break; 
      }

      //Dentro de ruta activa para garantizar la carga
      this.cargarGridcomponent();
      this.inicializar();
    });

  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };

    this.columnDefs = [
      { headerName: 'Núm. Andén', filter: true, resizable: true, width: 140, field: 'andenId',
        valueGetter: (params) => {
          const desc = params?.data?.descripcionAnden;
          return desc ? `${desc}` : '';
        }
      },
      { filter: true, resizable: true, width: 230, field: 'choferNombre' },
      { filter: true, resizable: true, width: 110, field: 'placa' },
      { filter: true, resizable: true, width: 110, field: 'furgon' },
      { filter: true, resizable: true, field: 'proveedorNombre' },
      { filter: true, resizable: true, field: 'centroDestinoNombre' },
      { filter: true, resizable: true, field: 'centroOrigenNombre' },
      { filter: true, resizable: true, field: 'clienteNombre' },
      { filter: true, resizable: true, width: 150, field: 'estado' },
      { filter: true, resizable: true, width: 120, field: 'garitaTicket', floatingFilter: true},
      { filter: true, resizable: true, width: 120, field: 'balanzaTicket', floatingFilter: true},
      { filter: true, resizable: true, width: 120, sortable: true, sort: 'desc', field: 'idViaje' },
      { filter: true, resizable: true, field: 'fechaLlegada' },
      { filter: true, resizable: true, width: 170, field: 'fechaRecepcion', headerName: 'Fecha Recepción' },
    ];

    this.columnDefs.push(
      { headerName: '', cellRenderer: 'buttonRenderer', initialPinned:"left", width: 80, minWidth: 80, maxWidth: 80, suppressSizeToFit: true, resizable: false, cellRendererParams: {onClick: this.verViaje.bind(this), label: 'Editar'} },
      { headerName: '', cellRenderer: 'buttonRenderer', initialPinned:"left", width: 130, minWidth: 130, maxWidth: 130, suppressSizeToFit: true, resizable: false, cellRendererParams: {onClick: this.nuevaAsignacion.bind(this), label: this.label} },
    );

    if(this.isOperador){
      this.columnDefs.push(
      { headerName: '', cellRenderer: 'buttonRenderer', initialPinned:"left", width: 130, minWidth: 130, maxWidth: 130, suppressSizeToFit: true, resizable: false, 
        cellRendererParams: {
          onClick: this.finalizarCarga.bind(this), 
          label: 'Fin Carga',
          colorBoton: 'btn btn-danger'
        } },
      );
    }

    this.rowSelection = 'multiple';
    this.rowClassRules = {
      'ag-row-sobrepeso': (params) => params?.data?.isSobrepeso === true,
    };
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  inicializar(){
    this.listTipos    = null;
    this.listCentros  = null;
    this.cmbxEstados  = this._catalogos.catalogoEstados();
    this.getMotivosBloqueoPlanificacion();
    
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res) => {
      if(res)this.listCentros = res;
    }, (err) => { 
      console.log(err.message); 
    });

    this.logisticaAPI.getTipos().subscribe((res) => {
      if(res) this.listTipos = res; 
    }, (err) => { 
      console.log(err.message); 
    });

    this.cargarTiposEstibas();
    this.listar();
    this.getUsuarioBascula();
    this.getAllMensajesMarquesinas();
  }

  cargarTiposEstibas() {
    this.tiposEstibas = [];
    this.logisticaAPI.getParametrosLogisticaName('TRACK_GENRL_TIPOS_ESTIBAS').subscribe((res: any) => {
      const root = Array.isArray(res) ? res?.[0] : res;
      const hijos = Array.isArray(root?.parametrosHijos) ? root.parametrosHijos : [];
      this.tiposEstibas = hijos.map((e) => ({
        id: e?.nombreParametro,
        label: e?.nombreParametro
      })).filter((e) => !!e.id);
    }, (err) => {
      console.log(err.message);
    });
  }

  verViaje({rowData}){
    this.isCreate  = false;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;

    this.formulario.reset();
    this.formulario.patchValue(rowData);

    this.getProveedor();
    this.getChofer();
    this.getAlmacen();
    this.openModal();
  }

  //anden = balanza_in, operador = anden_asigando, sellos, asignar_sellos
  listar(){
    this.rowData = null;
    this.mostrarForm = false;

    let estadoDeLista = this.cmbxEstados.filter(e=> e.proceso === this.routear)[0].clave;
    let estadoDeLista1 = this.cmbxEstados.filter(e=> e.proceso.toUpperCase == this.routear.toUpperCase);
    console.log("estados del listado", estadoDeLista);
    console.log("estados del listado", estadoDeLista1);
    
    //Estado de lista determinado por PROCESO Y RUTA CREADO Anden
    //antes estaba getViajesByEstadosAnden
    this.logisticaAPI.getViajesByEstadosAndenByidUser(this.usarioActual.id).subscribe((res) => {
      if(res) {
        if(this.isOperador){
          this.rowData = res.filter(item=> item.estado == 'ANDEN_ASIGNADO' || item.estado == 'ANDEN_CARGANDO');
        }else{
          this.rowData = res.filter(item=> item.estado == estadoDeLista)
        }
      };
      //this.rowData = res;
    }, (err) => { 
      console.log(err.message); 
    });    
    
    this.loading = false;
  }

  /** Si el form esta en modo de creación hará post caso contrario un update, ver variable isCreated */
  saveForm() {
    this.getFormValidationErrors();
    if (this.formAnden.invalid) return;

    let data = this.formAnden.getRawValue();
    
    this.loading  = true;
    const payload =  data;
    let mensajeP  = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;

    return;
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.logisticaAPI.createViaje(payload) : this.logisticaAPI.updateViaje(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  /** Si el form esta en modo de creación hará post caso contrario un update, ver variable isCreated */
  acciones(event) {

    if(event === 'regresar') {
      this.closeModal();
      this.selected = null;
      this.mostrarForm = false;
      this.imagenes = [];
      return ;
    }

    if(this.isOperador) {
        this.saveActividad();
      }else{
      this.saveForm();  
      }
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
    document.getElementById('cerrarModal1').click();
    document.getElementById('cerrarModal2').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  /** METODOS DE CONSULTAS  */
  proveedorSelected;
  getProveedor(){
    let pathParam = this.formulario.get('proveedorId').value;
  
    this.formulario.get('proveedorNombre').reset();
    this.dmaestrosAPI.getProveedorByID(pathParam).subscribe((res) => {
      if(res){
        this.proveedorSelected = res;
        this.formulario.get('proveedorNombre').setValue(this.proveedorSelected.nombre);;
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
        this.proveedorSelected = null;
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  // En la tabla de placas se encuentra tanto el Furgon como la Placa de cabezal
  getPlaca(isPlaca: boolean = true){
    let pathParam = isPlaca ? this.formulario.get('placa').value : this.formulario.get('furgon').value;

    if(isPlaca){
      this.formulario.get('proveedorId').reset();
      this.formulario.get('detallePlaca').reset();
    }else{
      this.formulario.get('detalleFurgon').reset();
    }

    this.dmaestrosAPI.getPlacabyId(pathParam).subscribe((res: Placa) => {
      if(res){
        if(isPlaca){
          this.formulario.get('proveedorId').setValue(res.cedula);
          this.formulario.get('detallePlaca').setValue(res.marca);
          this.getProveedor();
        }else{
          this.formulario.get('detalleFurgon').setValue(res.marca);
        }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => { 
      console.error(err.message); 
    });

  }

  getChofer(){
    let pathParam = this.formulario.get('choferCedula').value;
    this.formulario.get('choferNombre').reset();

    this.dmaestrosAPI.getChoferByCedula(pathParam).subscribe((res: Chofer) => {
      if(res){
        this.formulario.get('choferNombre').setValue(res.nombres);
        if(this.isCreate) 
          {
            this.formulario.get('choferTelefono').reset();
            this.formulario.get('choferTelefono').setValue(res.fono);
          }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }  

  getAlmacen(){
    let pathParam = this.formulario.get('centroOrigen').value;
    this.listAgencias = null;

    this.dmaestrosAPI.getAllAlmacenByCentro(pathParam).subscribe((res) => {
      if(res){
        this.listAgencias = res;
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  getDescaCentroMuelle(centro){
    this.logisticaAPI.getCentrosLogistica(centro).subscribe((res) => {
      if(res){
        this.CentroAlmacen = res.filter(item => item.idAlmacen == this.selected.bodegaCarga);
        this.formAnden.get('texto').setValue(this.CentroAlmacen == null ? "sin configuración" : this.CentroAlmacen[0].texto1);
      }
    }, (err) => { 
      console.info(err.message); 
    });
  }

  //tipoSelected : ITiposPlanificacion;
  tipoSelected : ITiposViajesShort;
  getTipoPlanificacion(idTipo){

    this.trackingConfiguracional.getTipoById(idTipo).subscribe((res) => {
      if(res){
        this.tipoSelected = res;
        console.log("tipo de planificacion");
      }
    }, (err) => { 
      console.info(err.message); 
    });
  }

  listMotivosDesbloqueo: any[];
  getMotivosBloqueoPlanificacion() {
    this.subscription.add(
      this.balanzaMotivosBloqueosAPI.obtener().subscribe(
        (resp) => {
          this.listMotivosDesbloqueo = resp.filter(e=> e.enPlanificacion);
          console.log("motivos bloqueo de planificaicon", this.listMotivosDesbloqueo);
        },
        (error) => {
          this.listMotivosDesbloqueo = [];
        }
      )
    );
  }


    /** METODOS DE CONSULTAS  */

  CentroAlmacen; 
  fechaInicioProceso;
  //this.textBotonGuardar = rowData.estado == "DOCUMENTADO" ? "Enviar a Balanza" : "Enviar a Cargar"; // asignar sellos
  //this.formAnden.get('modificadoPor').setValue(this.usarioActual.login2);
  //rowData.estado = 1;
  nuevaAsignacion({rowData}){
    this.selected = rowData;
    this.isCreate = true;
    this.loading  = true;
    this.imagenes = [];
    this.textBotonGuardar = "Enviar a Cargar";
    
    //GLPI #42031 | FOCUS - Mejoras al proceso 5.1
    const sellosLimpio = this.selected.sellos?.toString().trim();
    this.selected.sellos = (sellosLimpio && sellosLimpio.toLowerCase() !== 'null') ? sellosLimpio : '';

    if(this.selected.sellos?.length > 0) this.listSello = this.selected.sellos.split(',');
  
    this.formulario.patchValue(rowData);
    this.formAnden.reset();
    this.formAnden.patchValue(rowData);
    this.formAnden.get('viajeId').setValue(rowData.idViaje);
    this.formAnden.get('andenId').setValue(rowData.andenId);

    this.getAlmacen();
    console.log("ruta actual", this.routear);
    this.tipoSelected = rowData.tipoPlanificacion;
    
    switch(this.routear){
      case this.CONSTANTES.OPERADOR:
        this.isOperador   = true;
        this.mostrarForm  = this.isOperador;
        this.textBotonGuardar = "Enviar a Sellos";
        this.operador();
      break; 
      case this.CONSTANTES.SELLOS:
        this.listSello = [];
        document.getElementById('ModalSellos').click();
        this.label = "Enviar a Balanza Salida";
      break;
      default:
        document.getElementById('ModalAnden').click();
        this.getDescaCentroMuelle(rowData.centroOrigen);
        this.listarAndenes();
        this.getAreas();
        //this.getTipoPlanificacion(rowData.tipo);
      break; 
    }
    
    //this.selected = rowData;
    this.loading = false;

    this.formCarga.reset();
    this.formCarga.get('creadoPor').setValue(this.usarioActual.login2);
    this.formCarga.get('viajeId').setValue(this.selected.idViaje);
  }

  operador(){
    this.listarActividad();
    this.getDetalleCargas();
    this.formActividad.reset();
    this.formActividad.get('creadoPor').setValue(this.usarioActual.login2);
    this.formActividad.get('viajeId').setValue(this.selected.idViaje);
  }

  actualizarEstado({rowData}){
    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro que desea enviar a "+ this.selected.estado +" el viaje?",
        text    : 'VIAJE ' + rowData.idViaje,
        action  : "Actualizar Viaje",
        funcion : this.logisticaAPI.updateViajeEstado(rowData.idViaje, this.selected.estado, this.usarioActual.login2)
      }).then((resp: ITrackingViajes) => {
        this.loading = false;
        this.listar();        
        this.closeModal();
        //Integración bascula only control
        if(this.basculaUsuario?.sensorId != null){
          this.utilServices.mensajeOKToast("Seteando sentido y enviando marquesina", 2000);
          this.enviarMensajeMarquesina(resp.estado);
        }        
        
      }).catch(() => {
        this.loading = false;
      }).finally(() => {
        this.selected = null;
        this.listar();
      }); 
  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;
    Object.keys(this.formActividad.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formActividad.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    console.log('Number of errors: ', totalErrors);
  }

  closeModalBalanza() {
    document.getElementById('cerrarModalBalanza').click();
  }

  listarAndenes(){
    const centro = this.selected.centroOrigen;
    const almacen = this.selected.bodegaCarga;

    this.logisticaAPI.getMuelles(centro, almacen).subscribe((res) => {
      if(res)
        this.listAdenes = res;
        this.formAnden.get('andenId').setValue(this.selected.andenId);
    }, (err) => { 
      console.log(err.message); 
    });
    this.loading = false;
  }

  accionesAnden(event) {
    if (event === 'regresar') {
      this.selected = null;
      this.mostrarForm = false;
      return;
    }else{
      //this.saveForm();  
    }      
  }

  agregarDetalle(){
    let payload  = this.formAnden.getRawValue();
    payload.viaje= this.selected;
    //payload.anden = this.listAdenes.filter(item => item.idMuelle == payload.andenId)[0];

    const seleccion = this.formAnden.value.seleccion;
    console.log("seleccion", seleccion); // Aquí tienes el objeto completo
     console.log("payload", payload);  
    this.logisticaAPI.createAndenViaje(payload).subscribe((res) => {
      if(res)
        this.listarAsignacionActuales();
    }, (err) => { 
      this.utilServices.alertifyToastWar("No se puede agrega revise registro.")
      console.log(err.message); 
    });
  }

  listAsignaciones;
  listarAsignacionActuales(){
    this.logisticaAPI.getByViajeAnden(this.selected.idViaje).subscribe((response) => {
      console.log("responde de lista de asignaciones", response);
      if(response)
        this.listAsignaciones = response;
    }, (err) => { 
      console.log(err.message); 
    });
  }

  eliminarDetalle(viajeAnden){
    console.log("valor de la asignacion", viajeAnden);
    this.logisticaAPI.deleteAndenViaje(viajeAnden).subscribe((response) => {
      if(response)
        this.listarAsignacionActuales();
    }, (err) => { 
      console.log(err.message); 
      this.utilServices.alertifyToastWar("Error en eliminar andenes");
    });

    console.log("this.listAsignaciones", this.listAsignaciones);
  }

  agregarDetalleSellos(){
    let sello = this.formulario.get('sellosAdd').value;
    let found = this.listSello.includes(sello);

    if(sello == null || sello == undefined || sello == null || sello == ""){
      console.log("valor de sellos");
      this.utilServices.alertifyToastWar("Ingrese un registro valido");
      return;
    }

    if(found){
      this.utilServices.alertifyToastWar("Sello ya existe");
      return;
    }else{
      this.listSello.push(sello);
      let sellosFinal = this.listSello.join(',');
      this.formulario.get('sellos').setValue(sellosFinal);
      this.formulario.get('sellosAdd').reset();
      console.log("sellos", this.listSello);
    }
  }

  borrarDetalleSellos(index){
    this.listSello.splice(index, 1);
    let sellosFinal = this.listSello.join(',');
    this.formulario.get('sellos').setValue(sellosFinal);
    this.formulario.get('sellosAdd').reset();
    console.log("sellos", this.listSello);
  }

  colaboradores;
  getColaborador(){
    let nombres = this.formActividad.get('colaboradorNombre').value;

    this.nominaAPI.getEmpleadosNombresSearchByDeparment(nombres, this.usarioActual.login).subscribe((res) => {
      if(res){
        this.colaboradores = res.filter(e=> e.statusEmpleado == "Activo");
      }
    }, (err) => { 
      this.utilServices.alertifyToastWar("No se encontró colaboador");
      console.log(err.message); 
    });
  }

  saveActividad(){
    //const payload =  this.listColaborador;
    console.log("cargando actividad del personal {}", this.listColaborador);
    const payload = this.listColaborador.map(
      empleados => ({...empleados, ['estado']: 'ANDEN_CARGANDO' }));

    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro de enviar la lista de colaboradores",
        text    : 'Operadores a VIAJE ' + this.selected.idViaje,
        action  : "Agregar Actividad a Colaboradores",
        funcion : this.logisticaAPI.createActividadesColaboradores(payload)
      }).then(() => {
        this.loading = false;
        //this.listar();
      }).catch(() => {
        this.loading = false;
      });

  }

  listarActividad(){
    this.listColaborador = [];
    this.logisticaAPI.getByViajeActividad(this.selected.idViaje).subscribe((res) => {
      if(res){
        this.listColaborador = res;
        const tipoEstiba = this.formActividad.get('tipoEstiba').value;
        if (tipoEstiba) {
          this.listColaborador = (this.listColaborador || []).map((e) => ({ ...e, tipoEstiba }));
        }
      }
    }, (err) => { 
      this.utilServices.alertifyToastWar("No se encontró colaboador");
      console.log(err.message); 
    });
  }

  eliminarDetalleColaborador(index){
    //delete this.listColaborador.cedula;
    this.listColaborador.splice(index, 1);
    console.log("this.listColaborador", this.listColaborador);
  }

  listColaborador: any = [];
  agregarDetalleColaborador(){
    let colaborador = this.formActividad.get('colaborador').value;
    let colaboraRol = this.formActividad.get('colaboradorCargo').value;

    const foundItem = this.listColaborador.find(item => item.colaboradorCargo === colaboraRol);
    const foundItem1 = this.listColaborador.find(item => item.colaborador === colaborador);
    const registro  = this.formActividad.getRawValue();
    console.log("registro", registro);
    if(colaborador == null || colaborador == undefined){
      this.utilServices.alertifyToastWar("Ingrese un registro valido");
      return;
    }
    
    if(foundItem1){
      this.utilServices.alertifyToastWar("Registro ya existe");
      return;
    }

    if((colaboraRol == "VERIFICADOR" || colaboraRol == "MONTACARGISTA") && foundItem){
      this.utilServices.alertifyToastWar("Registro ya existe");
      return;
    }

    registro.colaboradorNombre = this.colaboradores.filter(e=> e.cedula == colaborador)[0].nombres;
    console.log("REGISTRO", registro);

    this.listColaborador.push(registro);
    this.formActividad.get('colaborador').reset();
    this.formActividad.get('colaboradorCargo').reset();
    this.formActividad.get('colaboradorNombre').reset();
    this.colaboradores = null;

    console.log("list colaboradores agregados", this.listColaborador);
  }
  
  estableEstados(tipo: string = 'anden'){
    switch (tipo) {
      /*case 'anden':
        this.actualizarAndenySellos();
        break; */
      case 'anden-fin':
        /*if(this.selected.estado == "DOCUMENTADO"){
           this.estableEstados('sellos-fin');
           return;
          }*/
          
           //rev1: Cris, revisiones de ampliación de Focus, para venta graneles. 
           //rev2: Se reconfigura para balanza_out, según alcance
           /*rev3: 24-04-2024(Definición mensajes/sentido semáforo Kosmos-Onlycontrol): nuevamente reconfigura condición, toma el camino por defecto
           * se comenta líneas de graneles

           let ventaGraneles = (this.tipoSelected.tipoEscenario == "VENTA" && this.selected.tipoCarga == 2);
           if(this.tipoSelected.tipoEscenario == "COMPRA" || this.tipoSelected.tipoEscenario == "INFORMATIVO" || ventaGraneles){
              this.selected.estado = 'BALANZA_OUT';
              this.actualizarEstado({rowData: this.selected});
              return;
           }*/
        
           this.selected.estado = 'ANDEN_ASIGNADO';
           this.actualizarAndenySellos(true);

        //this.actualizarEstado({rowData: this.selected});
        break; 
      case 'operador-inicio':
        this.selected.estado = 'ANDEN_CARGANDO';
        this.actualizarEstado({rowData: this.selected});
        break; 
      case 'operador-fin':
        this.selected.estado = 'ASIGNAR_SELLOS';

        /*rev1: 24-04-2024(Definición mensajes/sentido semáforo Kosmos-Onlycontrol):
        * va a balanza_out caso del modelo ampliado
        */
        let ventaGraneles = (this.tipoSelected.tipoEscenario == "VENTA" && this.selected.tipoCarga == 2);
        if(this.tipoSelected.tipoEscenario == "COMPRA" || this.tipoSelected.tipoEscenario == "INFORMATIVO" || ventaGraneles){
          this.selected.estado = 'BALANZA_OUT';
          this.actualizarEstado({rowData: this.selected});
          return;
        }

        this.actualizarAndenySellos(true);
        break; 
      case 'sellos-fin':
        //this.selected.estado = 'ANDEN_CARGADO';
         this.selected.estado =  this.selected.requiereDoc ? 'ANDEN_CARGADO' : 'BALANZA_OUT';
        this.actualizarAndenySellos(true);
        break; 
      default:
        this.selected.estado = 'ERROR_ESTADO';
        break; 
    }
  }

  actualizarAndenySellos(isAttachments: boolean = false){
    const andenId         = this.formAnden.get('andenId').value;
    this.selected.andenId = andenId == null ? 0 : andenId; // ojo con esto Cristhian me pidio pasarlo así, se pide validar los escenarios para evitar afectacion
    this.selected.sellos  = this.formulario.get('sellos')?.value;
    let data: any         = this.selected;

    if(isAttachments) data = this.setFormData(this.selected);
    const payload = data;
    console.log("Data de Envio", payload);
/*
    this.logisticaAPI.updateViajeSellosAnden(this.selected.idViaje, payload).subscribe((res) => {
      this.actualizarEstado({rowData: this.selected});
      this.actualizaMotivoDevolucion();
      this.acciones('regresar');
      //this.listarAsignacionActuales();
      this.utilServices.alertifyToastOK("Viaje actualizado con exito");
    }, (err) => { 
      this.utilServices.alertifyToastWar("No se puede agrega revise registro.")
        console.log(err.message); 
      });
      */

      this.utilServices.confirmarSincronoPromesa({
          title   : "¿Esta seguro que desea enviar a "+ this.selected.estado +" el viaje?",
          text    : 'VIAJE ' + this.selected.idViaje,
          action  : "Actualizar Viaje",
          funcion : this.logisticaAPI.updateViajeSellosAnden(this.selected.idViaje, payload)
        }).then((resp: ITrackingViajes) => {
          this.actualizaMotivoDevolucion();
          this.acciones('regresar');    
          this.listar();
          
          //Integración bascula only control
          if(this.basculaUsuario?.sensorId != null){
            this.utilServices.mensajeOKToast("Seteando sentido y enviando marquesina", 2000);
            this.enviarMensajeMarquesina(resp.estado);
          }

          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.log(err.message); 
        });


      this.loading = false;
  }

  resetSellos(){
    this.listSello = [];
    let sellosFinal = this.listSello.join(',');
    this.formulario.get('sellos').setValue(sellosFinal);
    console.info("valor del sello actual", this.formulario.get('sellos').value);
  }


  //Manejo de imagenes
  imagenes: File[] = [];
  errorArchivos: string = '';
  onFileSelected(event: Event){
    const fileInput = event.target as HTMLInputElement;
    if (!fileInput.files) return;
    
    this.imagenes   = [];
    const archivos  = Array.from(fileInput.files);
    const archivosValidos = archivos.filter(file =>
      ['image/png', 'image/jpeg'].includes(file.type)
    );
    
    if (archivosValidos.length !== archivos.length) {
      this.errorArchivos = 'Algunos archivos no son PNG o JPG válidos.';
      this.imagenes = [];
      return;
    }

    this.imagenes = archivosValidos;
    this.errorArchivos = '';
  }

  //formData.append('fotos', file, file.name)
  setFormData(data: any): FormData {
    const formData = new FormData();
    if (this.imagenes.length > 0) {
      this.imagenes.forEach((file) => {formData.append('imagenes', file);}); // archivos
    }
    //Valores necesarios para el servicio del back, no puede ir otro valor que el esperado
    formData.append('idViaje', data.idViaje);
    formData.append('tipo', data.tipo);
    formData.append('estado', data.estado);
    formData.append('sellos', data.sellos);
    formData.append('modificadoPor', data.modificadoPor);
    formData.append('andenId', data.andenId);

    /*Object.entries(data).forEach(
      ([key, value]) =>formData.append(key, value as string)
    ); // campos texto*/

    return formData;
  }

  getAreas(){
    const pathParam = this.formAnden.get('centroDestino').value == null ? this.formAnden.get('centroOrigen').value : this.formAnden.get('centroDestino').value;
    this.listAreas = [];
    this.trackingConfiguracional.getAreasbyCentro(pathParam).subscribe((res) => {
      if(res) {
        let areas = res.map(e => {e.descArea = e.nomeclatura + ' - ' + e.descArea; return e;});
        this.listAreas = areas.filter(e=> e.estado == 'A');
        
        // Setea por defecto el primer registro si la lista tiene datos
        if (this.listAreas.length > 0) {
          this.formAnden.get('areaId').setValue(this.listAreas[0].idArea);
        }
      }
    }, (err) => {
      console.log(err.message);
    });
  }


  /**INTEGRACION ONLY CONTROL
   * USUARIO Y BALANZA, INICIALIZA SERVICIOS Y ENVIA MENSAJES
   */
  
  //Obtiene el usuario para garita o bascula
  basculaUsuario : any;
  getUsuarioBascula(){
    const username =this.usarioActual.login2;
    this.usuarioBasculaAPI.obtenerPorUsuario(username, "bascula").subscribe(
      resp => {
        if (resp?.bascula) {
          let bascula = {
            idBascula: resp.bascula, 
            estado: resp.estadoBascula, 
            desca: resp.basculaDescripcion,
            sensorId: resp.sensorId,
            apiKey: resp.apiKey,
          };
          this.basculaUsuario = bascula;

          //Verifica test de conexión siempre que tenga Api Key
          if (resp.sensorId != null) {
            this.onlyControlSensoresAPI.setIntegration_ApiKey(resp.sensorId);
          }
          return;
        }
      },
      e => {console.error('Mensaje: ', e.error.mensaje, 'Respuesta', e.error.respuesta);}
    );
  }

  mensajesMarquesinas=[]; 
  getAllMensajesMarquesinas(){
    this.logisticaAPI.getMarquesinaMensajes().subscribe(resp => {
      if(resp){
        this.mensajesMarquesinas = resp;
      }
      console.log("mensajes marquesiana", this.mensajesMarquesinas);
    });
  }

  enviarMensajeMarquesina(tipoMensaje: String){
    console.log("buscar mensaje según estado", tipoMensaje);
    let filterMnsj = this.mensajesMarquesinas.find(e=> e.tipo === tipoMensaje);
    let lineasMnsj = filterMnsj ? filterMnsj.mensaje.split(",").map(m => ({texto: m.trim()})) : [];

    if(filterMnsj.indicador > 0) this.setearSentidoBascula(filterMnsj.indicador);

    if(lineasMnsj.length == 0){
      console.info("Marquesina sin mensajes", lineasMnsj.length);
      this.utilServices.alertifyToastWar("Sin mensajes para marquesina " + filterMnsj.marquesina.codigo);
      return;
    }

    const request: IMensajesRequest = {
      codigoBascula     : filterMnsj.marquesina.codigo,
      mensajesMarquesina: lineasMnsj
    };

    this.onlyControlSensoresAPI.postMensaje(request).subscribe(
      (resp) => {
        console.log(resp);
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error de Envio de mensajes", resp.detalle, 3000);    
          return; 
        }
        this.utilServices.alertifyToastOK("Mensaje de entrada enviado a la marquesina");
      },
      (error) => {
        this.utilServices.mensajeErrorVisto("Error en establecer mensaje");
        console.log("Error en establecer mensaje", error);
      }
    );
  }

  //Recibe sentido 1 o 2 dependiente si es Entrada o Salida
  setearSentidoBascula(sentido: number){
    const request: IBasculaSentidoRequest = {
      codigoBascula: this.basculaUsuario.sensorId,
      sentido: sentido
    };
    
    this.onlyControlSensoresAPI.postSentidoBascula(request).subscribe(
      (resp) => {
        this.utilServices.alertifyToastOK("Sentido establecido");
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error en establicer sentido", resp.detalle, 3000);
          return;
        }
      },
      (error) => {
        this.utilServices.mensajeErroToast("Error en establecer sentido");
        console.log("Error en establecer sentido", error);
      }
    );
  }  

  /*Metodos para proceso de detalle de cargas*/
  listadoCargas = [];
  saveDetalleCarga(){
    const payload = this.formCarga.getRawValue();
    this.logisticaAPI.createViajeCarga(payload).subscribe((res) => {
      if(res){
        this.utilServices.mensajeOKToast("Carga Actualizada");
        this.getDetalleCargas();
      }
    }, (err) => { 
      this.utilServices.mensajeErroToast(err.message, 3000);
      console.log(err.message); 
    });
  }

  getDetalleCargas(){
    this.listadoCargas = [];
    this.logisticaAPI.getByViajeCarga(this.selected.idViaje).subscribe((res) => {
      this.listadoCargas = res.filter(carga=> carga.tipo = "ADICIONALES");
      console.log("resultado de consulta de carga, ", res);
      console.log("listado de cargas", this.listadoCargas);
    }, (err) => { 
      console.error(err.message); 
    });
  }

  deleteCargas(item){
    this.logisticaAPI.deleteViajeCarga(item).subscribe((res) => {
        this.utilServices.mensajeOKToast("Carga eliminada exitosamente");
        this.getDetalleCargas();
    }, (err) => { 
      console.log(err.message); 
    });
  }

  actualizaMotivoDevolucion(){
    if(this.formActividad.get("motivoBloqueo")?.value == null) return;

    console.log("actualiza motivos devolucion", this.formActividad.get("motivoBloqueo").value);
    console.log("actualiza requiere doc", this.formActividad.get("requiereDoc").value);

    this.selected.motivoBloqueo = this.formActividad.get("motivoBloqueo").value;
    this.selected.requiereDoc = this.formActividad.get("requiereDoc").value == null ? false : this.formActividad.get("requiereDoc").value ;
      this.logisticaAPI.updateViajeBalanza(this.selected).subscribe((res) => {
        console.log("viaje actualizado", res)
      }, (err) => { 
        console.log(err.error.mensaje); 
      });
  }

  finalizarCarga({rowData}){
    if(rowData.estado != "ANDEN_CARGANDO") 
      return this.utilServices.mensajeErrorVisto("Viaje aún no se encuentra en ANDEN_CARGANDO", true, 5000);
  
    this.selected = rowData;
    this.selected.estado = 'ASIGNAR_SELLOS';
    this.selected.requiereDoc = true;
    
    //Escenario de Cristhian, ampliacion con balanza
    let ventaGraneles = (this.tipoSelected.tipoEscenario == "VENTA" && this.selected.tipoCarga == 2);
    if(this.tipoSelected.tipoEscenario == "COMPRA" || this.tipoSelected.tipoEscenario == "INFORMATIVO" || ventaGraneles){
      this.estableEstados('operador-fin');
      return;
    }

    this.actualizarEstado({rowData: rowData});
  }

}

